module.exports = __webpack_public_path__ + "img/gift4-01-c11-y1.15db3b8c.png";